import { SimuladorConsumosDet } from './../entities/simuladorConsumoDet.entity';
import { Respuesta } from './../entities/respuesta.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { validate, ValidationError } from 'class-validator';
import { SimuladorConsumoDetallado } from '../entities/simuladorConsumoDetallado.entity';

@Component({
  selector: 'app-simulador',
  templateUrl: './simuladorConsumo.component.html'
})
export class SimuladorConsumoComponent implements OnInit {
  public contratoCod: number;
  public numHab: string;
  public consumo: string;
  public rowsOnPage = 6;
  // public datosSimulador: SimuladorConsumos = new SimuladorConsumos();
  public datosSimuladorDetallado: SimuladorConsumoDetallado[] = new Array<SimuladorConsumoDetallado>();
  public datosSimulador: SimuladorConsumosDet = new SimuladorConsumosDet();
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public resultado: Respuesta;
  public direccionSuministro: string;
  public numHabInputError: boolean;
  public consumoInputError: boolean;
  public DatosObtenidos = false;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    if (this.sessionService.isAuthenticated) {
      this.clearInputErrors();
      // this.datosSimulador = new SimuladorConsumos();
      this.datosSimulador = new SimuladorConsumosDet();
      this.datosSimulador.simConsumoDetallado = new Array<SimuladorConsumoDetallado>();
      this.contratoCod = this.sessionService.contratoSelected.Codigo;
      this.direccionSuministro = this.sessionService.contratoSelected.InmuebleBO.Direccion;
      this.userService.getSimuladorConsumos(this.sessionService.explotacion, this.sessionService.contratoSelected.Codigo).
        subscribe(response => this.cargarTextos(response));
    } else {
      this.router.navigate(['/']);
    }
  }

  public recibirContrato(event): void {
    this.contratoCod = event.contratoSeleccionado.Codigo;
    this.direccionSuministro = event.contratoSeleccionado.InmuebleBO.Direccion;
    this.clearInputErrors();
  }

  public cargarTextos(response: SimuladorConsumosDet) {
    if (this.sessionService.datosExplotacion.Codigo.toUpperCase() === 'MELILLA') {
      this.datosSimulador.TextoAyuda = response.TextoAyuda.replace('factura', 'pre-factura');
    } else {
      this.datosSimulador.TextoAyuda = response.TextoAyuda.replace('factura', 'pre-factura');
    }
    this.datosSimulador.ConsumoFrecuencia = response.ConsumoFrecuencia;
  }

  public enviarSimulacion() {
    const textos = this.datosSimulador.TextoAyuda;
    const tipofrecuencia = this.datosSimulador.ConsumoFrecuencia;
    const nombre = this.datosSimulador.contratoNombre;
    this.datosSimulador = new SimuladorConsumosDet();
    this.datosSimulador.TextoAyuda = textos;
    this.datosSimulador.ConsumoFrecuencia = tipofrecuencia;
    this.datosSimulador.contratoNombre = nombre;

    this.clearInputErrors();
    this.datosSimulador.NumHab = this.numHab;
    this.datosSimulador.Consumo = this.consumo;
    this.datosSimulador.Contrato = this.contratoCod;
    this.datosSimulador.contratoNombre = this.sessionService.contratoSelected.ClienteNombre;

    validate(this.datosSimulador).then(resultado => {
      if (resultado.length > 0) {
        this.showErrors(resultado);
      } else {
        // this.userService.generarSimulacion(this.sessionService.explotacion, this.datosSimulador).subscribe(
        // response => this.generarSimulacionOnSuccess(response),
        // response => this.generarSimulacionOnError(response));
        this.userService.generarSimulacionDetallado(this.sessionService.explotacion, this.datosSimulador).subscribe(
          response => this.generarSimulacionOnSuccess(response),
          response => this.generarSimulacionOnError(response));
      }
    });
  }

  public generarSimulacionOnSuccess(response) {
    const resultadoSimulador: SimuladorConsumosDet = response;
    this.datosSimulador = resultadoSimulador;
    this.datosSimuladorDetallado = resultadoSimulador.simConsumoDetallado;
    this.DatosObtenidos = true;
  }

  public generarSimulacionOnError(response) {
    this.resultado = response;
    this.messageCabecera = 'Error en la simulación de los consumos';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al simular los consumos';
      this.typeException = 1;
    }
  }

  public descargarSimulacion() {
    this.userService.descargarSimulacion(this.sessionService.explotacion, this.datosSimulador).subscribe(
      response => this.descargarSimulacionOnSuccess(response),
      response => this.descargarSimulacionOnError(response));
  }

  public descargarSimulacionOnSuccess(response) {
    const fichero: Blob = response;
    const filename = 'simulacion.pdf';
    FileSaver.saveAs(fichero, filename);
  }

  public descargarSimulacionOnError(response) {
    this.resultado = response;
    this.messageCabecera = 'Error en al descargar';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al descargar la simulación de los consumos';
      this.typeException = 1;
    }
  }

  public showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'Consumo':
          this.consumoInputError = true;
          break;
        case 'NumHab':
          this.numHabInputError = true;
      }
    }
  }

  public clearInputErrors() {
    this.numHabInputError = false;
    this.consumoInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/simuladorConsumo.component.ts